/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { CommonShowModuleContentApplicationValues } from './commonShowModuleContentApplicationModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'common-show-module-content-application-modal',
    standalone: false,
})
export class CommonShowModuleContentApplicationModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Input() resolve: CommonShowModuleContentApplicationValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('commonShowModuleContentApplicationModal', elementRef, injector);
    }
}
